import { Box, WizardStep, WizardStepRenderParams } from '@factorialco/deprecated-design-system'

import SelectField from 'modules/core/components/SelectField'
import TextArea from 'modules/core/components/TextArea'
import TextField from 'modules/core/components/TextField'
import i18n from 'modules/core/lib/i18n'

import { WizardWorkingConditions } from 'modules/job_catalog/components/WorkingConditionsModal/models/wizardWorkingConditions'

interface Props {
  nodeName: string
}

const GeneralInformationStep = ({
  nodeName,
  data,
  onDataChanged,
}: WizardStepRenderParams<WizardWorkingConditions> & Props) => {
  return (
    <Box flexDirection="row">
      <Box width="s400" paddingTop="s40" gap="s24">
        <TextField
          label={i18n.t('job_catalog.nodes.working_conditions.modal.general_information.name')}
          value={data.name}
          onChange={(value) => onDataChanged({ ...data, name: value })}
          mandatory
          placeholder={i18n.t(
            'job_catalog.nodes.working_conditions.modal.general_information.name_placeholder',
            { nodeName }
          )}
        />
        <TextArea
          label={i18n.t(
            'job_catalog.nodes.working_conditions.modal.general_information.description'
          )}
          value={data.description ?? undefined}
          onChange={(value) => onDataChanged({ ...data, description: value })}
          placeholder={i18n.t(
            'job_catalog.nodes.working_conditions.modal.general_information.description_placeholder',
            { nodeName }
          )}
        />
        <SelectField
          label={i18n.t(
            'job_catalog.nodes.working_conditions.modal.general_information.workplaces.label'
          )}
          options={[
            {
              label: i18n.t(
                'job_catalog.nodes.working_conditions.modal.general_information.workplaces.default_option'
              ),
              value: 'all',
            },
          ]}
          defaultValue="all"
          none={i18n.t('common.select')}
          readonly
        />
      </Box>
      <Box maxWidth="s240" />
    </Box>
  )
}

const isCompleted = (data: WizardWorkingConditions): boolean => {
  return !!data.name
}
export const generalInformationStep = (nodeName: string): WizardStep<WizardWorkingConditions> => ({
  title: i18n.t('job_catalog.nodes.working_conditions.modal.general_information.title'),
  nextText: i18n.t('common.next'),
  render: (props) => <GeneralInformationStep {...props} nodeName={nodeName} />,
  isCompleted,
})
